import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {reduxForm, Field, formValueSelector } from 'redux-form';

import IconButton from 'material-ui/IconButton';
import CreateIcon from 'material-ui/svg-icons/content/create';

import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import MenuItem from 'material-ui/MenuItem';

import { required, length } from 'redux-form-validators';

import { SelectField, TextField } from 'redux-form-material-ui'

import { changePort } from 'actions/regions/ports';

import gmtData from 'data/gmt';

import { formName } from 'data/formNames';

const styles = {
    dialog: {
        contentStyle: {width: '300px', padding: '18px'},
    },
    textField: {
        floatingLabelStyle: { fontSize: '12px' },
    },
    icon: { color: '#CBCBCB' },
};

class Sidebar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openDialog: false,
        };

        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
    }

    handleOpenDialog() {
        this.setState({
            openDialog: true,
        });
    }

    handleCloseDialog() {
        this.setState({
            openDialog: false,
        })
    }

    render() {
        const { openDialog } = this.state;
        const { port, countries } = this.props;

        return (
            <Fragment>
                <Dialog
                    modal={false}
                    open={openDialog}
                    contentStyle={styles.dialog.contentStyle}
                    onRequestClose={this.handleCloseDialog}
                >
                    <form>
                        <Field
                            component={TextField}
                            name={'name'}
                            floatingLabelText='Name'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            validate={[required(), length({ min: 3 })]}
                            fullWidth
                        />

                       <Field
                            component={SelectField}
                            name={'country._id'}
                            floatingLabelText='Country'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            autoWidth
                            validate={required()}
                            onChange={(e, value) => {
                                e.preventDefault();

                                this.props.change('country', this.props.countries.find((country) => {
                                    return country._id === value;
                                }));
                            }}
                            fullWidth
                        >
                            {
                                countries.map((country, key) => {
                                    return (<MenuItem
                                        key={key}
                                        value={country._id}
                                        primaryText={country.name} />)
                                })
                            }
                        </Field>

                        <Field
                            component={TextField}
                            name={'unLoCode'}
                            floatingLabelText='UN LOCODE'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            fullWidth
                            validate={[length({ max: 5 })]}
                        />

                        <Field
                            component={SelectField}
                            name={'timezone'}
                            floatingLabelText='timezone'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            fullWidth
                        >
                            {
                                gmtData.map((gmt, key) => {
                                    return (<MenuItem key={key} value={gmt} primaryText={gmt} />)
                                })
                            }
                        </Field>

                        <Field
                            component={TextField}
                            name={'site'}
                            floatingLabelText='Web site'
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                            fullWidth
                            validate={[ length({ min: 8, allowBlank: true })]}
                        />

                        <div style={{ display: 'flex' }} className='between-xs'>

                        <FlatButton
                            label="Cancel"
                            onClick={this.handleCloseDialog}
                            secondary
                        />
                        <RaisedButton
                            label="Save"
                            style={{ background: '#7FC931' }}
                            primary
                            onClick={this.props.handleSubmit((submit) => {
                                 this.handleCloseDialog();
                                 this.props.changePort(submit);
                            })}
                        />
                        </div>
                    </form>
                </Dialog>

                <div className="col-lg-3 col-xs-3 sidebar">
                    <Field
                        component={({ input, label, type, port, meta: { touched, error } }) => (
                            <div className={error ? "validate-error name" : "name"}>
                                {`${port.name} ${error ? error : ''}`}
                            </div>
                        )}
                        name={'name'}
                        props={{port}}
                    />

                    <Field
                        component={({ input, label, type, port, meta: { touched, error } }) => (
                            <div className={error ? "validate-error name country" : "name country"}>
                                {`${port.country ? port.country.name : ''} ${error ? error : ''}`}
                            </div>
                        )}
                        name={'country.name'}
                        props={{port}}
                    />

                    <div className="divider" />

                    <div className='info'>
                        <Field
                            component={({ input, label, type, port, meta: { touched, error } }) => (
                                <div className={error ? "validate-error info__title" : "info__title"}>
                                    <span>UN LOCODE: </span> {`${port.unLoCode} ${error ? error : ''}`}
                                </div>
                            )}
                            name={'unLoCode'}
                            props={{port}}
                        />

                        <Field
                            component={({ input, label, type, port, meta: { touched, error } }) => (
                                <div className={error ? "validate-error info__title" : "info__title"}>
                                    <span>Time Zone:</span>  {`${port.timezone} ${error ? error : ''}`}
                                </div>
                            )}
                            name={'timezone'}
                            props={{port}}
                        />

                        <Field
                            component={({ input, label, type, port, meta: { touched, error } }) => (
                                <a className={error ? "validate-error info__website" : "info__website"}>
                                   {`${port.site ? port.site : ''} ${error ? error : ''}`}
                                </a>
                            )}
                            name={'site'}
                            props={{port}}
                        />

                        <div className="info__change">
                            <IconButton
                                iconStyle={styles.icon}
                                onClick={this.handleOpenDialog}>
                                <CreateIcon
                                    style={styles.icon}
                                />
                            </IconButton>
                        </div>

                    </div>
                </div>
            </Fragment>
        );
    }
}

Sidebar.propTypes = {
    port: PropTypes.object,
};

Sidebar.defaultProps = {
    port: {},
};

const MyForm = reduxForm({
    form: formName.portUpdate,
    enableReinitialize: true,
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
})(Sidebar);

const selector = formValueSelector(formName.portUpdate);
export default connect(
    (state) => {

        return {
            countries: state.countries.items,
            initialValues: { ...state.port },
            port: selector(state,  'name', 'timezone', 'country', 'unLoCode', 'site'),
        };
    },
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(MyForm);


// WEBPACK FOOTER //
// ./app/components/Regions/Port/Sidebar.jsx